// src/components/ThemeToggle.jsx
//
// Shared 3-segment color-theme control (Dark / Light / Minimalist). Single source of
// truth for the toggle UI: used by the reader prefs bar AND the Navbar (so signed-out
// visitors on any public page, incl. HomePage, can switch theme). Reads + writes the
// app-wide colorMode via ReadingPrefsContext (lifted to the App root), so a change here
// updates the whole app and persists through the existing useReadingPrefs localStorage.
import React, { useContext } from 'react';
import { ReadingPrefsContext } from '../pages/useReadingPrefs.js';

// colorMode value -> user-facing label ('muji' shows as "Minimalist").
const THEME_SEGMENTS = [['night', 'Dark'], ['day', 'Light'], ['muji', 'Minimalist']];

// `compact` (navbar usage): tighter tracking + nowrap + no-shrink so the full word
// "Minimalist" never wraps or clips in the dense navbar row beside the cart icon. The
// reader prefs bar uses the default (non-compact) form, unchanged.
export default function ThemeToggle({ className = '', compact = false }) {
    const { colorMode, setColorMode } = useContext(ReadingPrefsContext);
    const segPad = compact ? 'px-1.5 whitespace-nowrap' : 'px-2';
    return (
        <div className={`flex items-center border border-book-accent/25 rounded-sm overflow-hidden ${compact ? 'flex-shrink-0' : ''} ${className}`.trim()}>
            {THEME_SEGMENTS.map(([mode, label]) => {
                const active = colorMode === mode;
                return (
                    <button key={mode} onClick={() => setColorMode(mode)} title={`Theme: ${label}`}
                        aria-pressed={active}
                        className={`${segPad} leading-none flex items-center justify-center transition-colors h-10 md:h-[26px] font-display text-xs font-semibold ${
                            active ? 'bg-book-accent text-book-pageDark' : 'text-book-muted hover:text-book-accent'
                        }`}>
                        {label}
                    </button>
                );
            })}
        </div>
    );
}
